const apiService = async ({ uri, method = 'GET', type = 'FILE', data = null, headers = {} }) => {
  const url = uri;
  const config = {
    method,
    headers: {
      ...headers,
    },
  };

  // 如果是 FormData 类型的请求体，直接使用，不需要 JSON.stringify
  if (data && !(data instanceof FormData) && !['GET', 'DELETE'].includes(method.toUpperCase())) {
    config.body = JSON.stringify(data);
    config.headers['Content-Type'] = 'application/json'; // 仅对非 FormData 请求设置 JSON 类型
  } else if (data instanceof FormData) {
    config.body = data; // 直接使用 FormData，不需要修改 headers
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('Content-Type') || '';

    if (method.toUpperCase() === 'GET' && type === 'FILE') {
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;

      const contentDisposition = response.headers.get('Content-Disposition');
      const filename = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
        : 'downloaded_file.zip';

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
      return;
    }

    if (contentType.includes('application/json')) {
      return await response.json();
    } else if (contentType.includes('text/')) {
      return await response.text();
    } else {
      return response;
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export default apiService;
